<template>
  <div class="chart-container">
    <VChart :option="chartOptions" autoresize v-if="hasChartSeries" />
    <div class="font-italic text-muted w-100 h-100" v-if="!hasChartSeries" style="display: flex">
      <div class="m-auto">No data available</div>
    </div>
  </div>
</template>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.chart-tools {
  position: absolute;
  top: 10px;
  right: 10px;
  width: auto;
  height: auto;
  text-align: right;
}
</style>

<script>
import _ from 'lodash'

import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { TreemapChart } from 'echarts/charts';
import { TitleComponent, TooltipComponent, LegendComponent, GridComponent, GraphicComponent } from 'echarts/components';
import VChart from 'vue-echarts';

use([
  CanvasRenderer,
  TreemapChart,
  GridComponent,
  GraphicComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);

export default {
  name: 'ChartTreeMap',
  components: {
    VChart
  },
  props: {
    title: String,
    series: Array,
    xAxis: [Array, Object],
    yAxis: [Array, Object],
    legend: [Array, Object],
    options: Object,
  },
  computed: {
    hasChartSeries() {
      if(this.series) {
        return this.series.some(series => {
          if(series.data && series.data.length > 0)
            return true
        })
      }
      return false
    },
    chartOptions() {
      var output = {}

      output.legend = this.legend
      output.xAxis = this.xAxis
      output.yAxis = this.yAxis
      output.series = this.series

      // Default options
      output.tooltip = {
        trigger: 'axis'
      },

      _.merge(output, this.options)

      return output
    }
  },
  methods: {
    
  }
}
</script>